import axios from "axios";
import { formatISO } from "date-fns";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { PaginationMetadata } from "../../Types";
import ValidationError from "../../ZodError";
import { TradeProposalId } from "../types";
const ResponseSchema = z.object({
    data: z.array(TradeProposalId),
    pagination: PaginationMetadata,
});
export const url = (tradeProposalId, queryString) => {
    const qs = new URLSearchParams();
    if (queryString.page !== undefined) {
        qs.append("page", queryString.page.toString());
    }
    if (queryString.pageSize !== undefined) {
        qs.append("pageSize", queryString.pageSize.toString());
    }
    if (queryString.orderBy !== undefined) {
        qs.append("orderBy", queryString.orderBy);
    }
    if (queryString.proposalStatus !== undefined) {
        queryString.proposalStatus.forEach((status) => {
            qs.append("proposalStatus", status);
        });
    }
    if (queryString.submittedAtGt !== undefined) {
        qs.append("submittedAtGt", formatISO(queryString.submittedAtGt));
    }
    if (queryString.submittedAtLt !== undefined) {
        qs.append("submittedAtLt", formatISO(queryString.submittedAtLt));
    }
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/investment/trade-proposals/${tradeProposalId}/related?${qs.toString()}`
        : `https://middleware.uat.farther.com//investment/trade-proposals/${tradeProposalId}/related?${qs.toString()}`;
};
export async function getRelatedTradeProposals(tradeProposalId, queryString, config) {
    const { data } = await axios.get(url(tradeProposalId, queryString), {
        headers: {
            version: "20250120",
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
        },
    });
    const decoded = ResponseSchema.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[getRelatedTradeProposals] received unexpected data`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getRelatedTradeProposals.js.map